module.exports = __webpack_public_path__ + "static/player-blank-1d0bb118df5154bea5642ff37c79eab8.jpg";